import React from 'react';
import Wrapper from './styles';
import UiBadge from '../../ui/badge/UiBadge';
import { OnsiteMessageTab } from '../../../microservices/crm/types';
import { translate } from '../../../services/translate';
import { onsiteMessageTabsTranslations } from '../../../services/onsite-messages';

interface Props {
    tab: OnsiteMessageTab;
    unreadMessagesTotal: number;
    isSelected: boolean;
    isDisabled: boolean;
    className?: string;
    onTabClick: () => void;
}

export default function CrmTabItem({ tab, unreadMessagesTotal, isSelected, isDisabled, className, onTabClick }: Props) {
    return (
        <Wrapper
            size="default"
            key={tab}
            onClick={onTabClick}
            selected={isSelected}
            isDisabled={isDisabled}
            className={className}
        >
            <div className="inbox-tab-label">
                {translate(onsiteMessageTabsTranslations[tab].tab, 'crm.dropdown')}
                <UiBadge badge={unreadMessagesTotal} />
            </div>
        </Wrapper>
    );
}
